<button class="button-wrapper">
    <div class="d-flex flex-row justify-content-between align-items-center">
        <h2>{{ label() }}</h2>
        <img [src]="IMAGE_URLS.arrowRightBlack" class="nav-icon" />
    </div>
</button>